import React, { useContext, useState, useEffect, useCallback } from "react";
import { LanguageContext } from "../context/LanguageContext";
import Header from "../components/header";

const DARK    = "rgb(46,46,46)";
const DARK2   = "rgb(38,38,38)";
const CARD_BG = "rgb(54,54,54)";
const TEXT    = "rgb(198,198,198)";
const BLUE    = "rgb(37,71,122)";
const YT_CH   = "https://www.youtube.com/@Techtalamo";

const VIDEOS = [
  { titleKey: "help_vid1_title", sectionKey: "help_vid1_sec", videoId: "" },
  { titleKey: "help_vid2_title", sectionKey: "help_vid2_sec", videoId: "" },
  { titleKey: "help_vid3_title", sectionKey: "help_vid3_sec", videoId: "" },
  { titleKey: "help_vid4_title", sectionKey: "help_vid4_sec", videoId: "" },
  { titleKey: "help_vid5_title", sectionKey: "help_vid5_sec", videoId: "" },
  { titleKey: "help_vid6_title", sectionKey: "help_vid6_sec", videoId: "" },
];

// ── Modal de video ─────────────────────────────────────────────────────────────
function VideoModal({ video, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 9998,
        background: "rgba(0,0,0,0.88)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "20px",
        animation: "fadeIn 0.18s ease",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%", maxWidth: 860,
          background: DARK2, borderRadius: 14,
          overflow: "hidden",
          boxShadow: "0 24px 60px rgba(0,0,0,0.7)",
          animation: "scaleIn 0.18s ease",
        }}
      >
        {/* Header del modal */}
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          padding: "14px 18px", borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}>
          <div>
            <p style={{ margin: 0, fontSize: 11, color: "rgba(198,198,198,0.45)", textTransform: "uppercase", letterSpacing: 1 }}>
              {video.section}
            </p>
            <p style={{ margin: "2px 0 0", fontSize: 15, fontWeight: 600, color: "#fff" }}>{video.title}</p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none", border: "none", color: "rgba(255,255,255,0.5)",
              fontSize: 22, cursor: "pointer", lineHeight: 1, padding: "4px 8px",
              transition: "color 0.15s",
            }}
            onMouseEnter={e => e.currentTarget.style.color = "#fff"}
            onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.5)"}
          >
            ✕
          </button>
        </div>

        {/* Contenido: video o "próximamente" */}
        {video.videoId ? (
          <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
            <iframe
              src={`https://www.youtube.com/embed/${video.videoId}?autoplay=1`}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none" }}
            />
          </div>
        ) : (
          <div style={{
            height: 320, display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center", gap: 16,
            background: "rgb(28,28,28)",
          }}>
            <svg width="64" height="44" viewBox="0 0 48 34" fill="none">
              <rect width="48" height="34" rx="8" fill="#FF0000" opacity="0.7" />
              <polygon points="19,9 19,25 34,17" fill="#fff" />
            </svg>
            <p style={{ color: "rgba(255,255,255,0.45)", margin: 0, fontSize: 14 }}>
              Video próximamente disponible
            </p>
            <a
              href={YT_CH}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-light btn-sm px-3"
              style={{ fontSize: 13 }}
            >
              Ver canal de YouTube
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Tarjeta de video (siempre clickeable) ─────────────────────────────────────
function VideoCard({ title, section, videoId, onSelect }) {
  return (
    <div
      className="lp-card"
      onClick={onSelect}
      style={{ background: CARD_BG, borderRadius: 10, overflow: "hidden", cursor: "pointer" }}
    >
      {/* Miniatura / placeholder */}
      <div style={{
        position: "relative", background: "rgb(30,30,30)", height: 160,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        {videoId ? (
          <img
            src={`https://img.youtube.com/vi/${videoId}/mqdefault.jpg`}
            alt={title}
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
        ) : (
          <svg width="48" height="34" viewBox="0 0 48 34" fill="none">
            <rect width="48" height="34" rx="8" fill="#FF0000" opacity="0.6" />
            <polygon points="19,9 19,25 34,17" fill="#fff" />
          </svg>
        )}
        {/* Botón play overlay */}
        <div style={{
          position: "absolute", inset: 0,
          display: "flex", alignItems: "center", justifyContent: "center",
          background: "rgba(0,0,0,0.3)",
          transition: "background 0.2s",
        }}
          onMouseEnter={e => e.currentTarget.style.background = "rgba(0,0,0,0.5)"}
          onMouseLeave={e => e.currentTarget.style.background = "rgba(0,0,0,0.3)"}
        >
          <div style={{
            width: 48, height: 48, borderRadius: "50%",
            background: "rgba(255,255,255,0.15)",
            display: "flex", alignItems: "center", justifyContent: "center",
            backdropFilter: "blur(4px)",
          }}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="white">
              <polygon points="4,2 16,9 4,16" />
            </svg>
          </div>
        </div>
      </div>

      {/* Info */}
      <div style={{ padding: "12px 14px" }}>
        <p style={{ margin: 0, fontSize: 11, color: "rgba(198,198,198,0.45)", textTransform: "uppercase", letterSpacing: 1 }}>
          {section}
        </p>
        <p style={{ margin: "4px 0 0", fontSize: 14, fontWeight: 600, color: "#fff" }}>{title}</p>
      </div>
    </div>
  );
}

// ── FAQ item ──────────────────────────────────────────────────────────────────
function FaqItem({ question, answer, index, openIndex, setOpenIndex }) {
  const isOpen = openIndex === index;
  return (
    <div style={{ borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
      <button
        onClick={() => setOpenIndex(isOpen ? null : index)}
        style={{
          width: "100%", textAlign: "left", background: "none", border: "none",
          color: "#fff", padding: "14px 16px", fontSize: 15, fontWeight: 600,
          cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center",
        }}
      >
        <span>{question}</span>
        <span style={{ fontSize: 18, opacity: 0.6, flexShrink: 0, marginLeft: 12 }}>
          {isOpen ? "−" : "+"}
        </span>
      </button>
      {isOpen && (
        <div style={{ padding: "0 16px 16px", color: TEXT, fontSize: 14, lineHeight: 1.7 }}>
          {answer}
        </div>
      )}
    </div>
  );
}

// ── Página principal ──────────────────────────────────────────────────────────
const HelpCenter = () => {
  const { t } = useContext(LanguageContext);
  const [openIndex, setOpenIndex]     = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const closeModal = useCallback(() => setSelectedVideo(null), []);

  const faqs = [
    { q: t("help_faq_q1"),  a: t("help_faq_a1") },
    { q: t("help_faq_q2"),  a: t("help_faq_a2") },
    { q: t("help_faq_q3"),  a: t("help_faq_a3") },
    { q: t("help_faq_q4"),  a: t("help_faq_a4") },
    { q: t("help_faq_q5"),  a: t("help_faq_a5") },
    { q: t("help_faq_q6"),  a: t("help_faq_a6") },
    { q: t("help_faq_q7"),  a: t("help_faq_a7") },
    { q: t("help_faq_q8"),  a: t("help_faq_a8") },
    { q: t("help_faq_q9"),  a: t("help_faq_a9") },
    { q: t("help_faq_q10"), a: t("help_faq_a10") },
  ];

  return (
    <div className="body" style={{ background: DARK, minHeight: "100vh", color: TEXT }}>
      <Header />

      {/* ── Hero ── */}
      <div style={{ background: BLUE, padding: "40px 24px", textAlign: "center" }}>
        <h2 style={{ color: "#fff", marginBottom: 8 }}>{t("help_title")}</h2>
        <p style={{ color: "rgba(255,255,255,0.75)", maxWidth: 600, margin: "0 auto", fontSize: 15 }}>
          {t("help_subtitle")}
        </p>
      </div>

      <div style={{ maxWidth: 1000, margin: "0 auto", padding: "40px 24px" }}>

        {/* ── FAQ ── */}
        <h4 style={{ color: "#fff", marginBottom: 20 }}>{t("help_faq_title")}</h4>
        <div style={{ background: DARK2, borderRadius: 12, marginBottom: 48, overflow: "hidden" }}>
          {faqs.map((item, i) => (
            <FaqItem
              key={i} index={i}
              question={item.q} answer={item.a}
              openIndex={openIndex} setOpenIndex={setOpenIndex}
            />
          ))}
        </div>

        {/* ── Videos ── */}
        <h4 style={{ color: "#fff", marginBottom: 8 }}>{t("help_videos_title")}</h4>
        <p style={{ color: TEXT, opacity: 0.7, marginBottom: 24, fontSize: 14 }}>
          {t("help_videos_sub")}
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 20 }}>
          {VIDEOS.map((v, i) => (
            <VideoCard
              key={i}
              title={t(v.titleKey)}
              section={t(v.sectionKey)}
              videoId={v.videoId}
              onSelect={() => setSelectedVideo({ title: t(v.titleKey), section: t(v.sectionKey), videoId: v.videoId })}
            />
          ))}
        </div>

        {/* ── Link canal YouTube ── */}
        <div style={{ textAlign: "center", marginTop: 36 }}>
          <a
            href={YT_CH} target="_blank" rel="noopener noreferrer"
            className="btn btn-outline-light px-4 py-2"
            style={{ fontSize: 14 }}
          >
            <i className="bi bi-youtube me-2" style={{ color: "#FF0000" }}></i>
            {t("help_yt_cta")}
          </a>
        </div>
      </div>

      {/* ── Modal ── */}
      {selectedVideo && <VideoModal video={selectedVideo} onClose={closeModal} />}

      <style>{`
        @keyframes fadeIn  { from { opacity: 0 } to { opacity: 1 } }
        @keyframes scaleIn { from { transform: scale(0.93) } to { transform: scale(1) } }
      `}</style>
    </div>
  );
};

export default HelpCenter;
